import * as Yup from "yup";

const modeloTributacaoValidator = Yup.object().shape({
  descricao: Yup.string().required("Descrição"),
});

export default modeloTributacaoValidator;
